export class GradeLotInvModel {
    lotNo: string;
    count: number;
    quantity: number;
    assignedQty: number;
    plannedSoNumber: string;
    poNumber?:string;
    saleOrderId?:number

    constructor(lotNo: string,count: number,quantity: number,assignedQty: number,plannedSoNumber: string,poNumber?:string,saleOrderId?:number){
        this.lotNo = lotNo;
        this.count = count;
        this.quantity = quantity;
        this.assignedQty = assignedQty;
        this.plannedSoNumber = plannedSoNumber;
        this.poNumber = poNumber;
        this.saleOrderId = saleOrderId;
    }
}